export default {
  workplace(state) {
    return state.workplace
  },
  workplaces(state) {
    return state.workplaces
  },
  workplaceFilters(state) {
    return state.workplaceFilters
  },
  workplacePermissions(state) {
    return state.workplacePermissions
  },
}
